import { Link } from 'react-router-dom';
import { categoryEntries } from '@/mocks/home';

export default function CategoryEntries() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="mb-10 md:mb-14">
          <p className="font-heading text-sm uppercase tracking-[0.3em] text-foreground-500 mb-2">
            HANMAN
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-900 leading-tight">
            探索漫画分类
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <Link
            to="/"
            className="group relative bg-foreground-950 rounded-[28px] p-8 md:p-10 flex flex-col justify-between min-h-[280px] overflow-hidden cursor-pointer"
          >
            <div className="relative z-10">
              <div className="w-12 h-12 rounded-2xl bg-foreground-800 flex items-center justify-center">
                <i className={`${categoryEntries[0].icon} text-xl text-background-50`}></i>
              </div>
            </div>
            <div className="relative z-10 mt-auto">
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-background-50 group-hover:text-primary-400 transition-colors">
                {categoryEntries[0].title}
              </h3>
              <p className="mt-2 text-sm text-foreground-400">{categoryEntries[0].subtitle}</p>
            </div>
          </Link>

          <Link
            to="/"
            className="group relative rounded-[28px] overflow-hidden min-h-[280px] cursor-pointer"
          >
            <img
              src={categoryEntries[1].image}
              alt={categoryEntries[1].title}
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
            <div className="relative z-10 h-full flex flex-col justify-end p-8 md:p-10">
              <span className="inline-flex items-center gap-2 bg-black/40 backdrop-blur-sm text-background-50 text-xs font-medium px-3 py-1.5 rounded-full w-fit mb-3">
                <i className={`${categoryEntries[1].icon} text-sm`}></i>
                {categoryEntries[1].title}
              </span>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                {categoryEntries[1].subtitle}
              </h3>
            </div>
          </Link>

          <Link
            to="/"
            className="group relative bg-background-50 rounded-[28px] p-8 md:p-10 flex flex-col justify-between min-h-[280px] border border-background-200/70 cursor-pointer"
          >
            <div className="relative z-10">
              <h3 className="font-heading text-5xl md:text-6xl font-black text-foreground-900 group-hover:text-primary-500 transition-colors">
                {categoryEntries[2].title}
              </h3>
              <p className="mt-3 text-sm text-foreground-500">{categoryEntries[2].subtitle}</p>
            </div>
            <div className="relative z-10 mt-6">
              <div className="w-full h-32 rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20action%20scene%2C%20martial%20arts%20fighter%20in%20mid-air%20with%20energy%20effects%2C%20dramatic%20lighting%2C%20epic%20battle%20atmosphere%2C%20warm%20and%20intense%20color%20palette%2C%20digital%20art%20illustration%2C%20clean%20composition%2C%20action%20and%20adventure%20theme&width=800&height=400&seq=category-action-01&orientation=landscape"
                  alt={categoryEntries[2].title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}